<script setup lang="ts">
import List from "@/views/playground/player/partner/planner/List.vue";
</script>
<template>
  <list></list>
</template>
<style scoped></style>
